import { type MemberType } from './types'

export const MEMBER_TYPES: MemberType[] = [
  {
    type: 'Super Admin',
    content:
      'The primary account holder of the organization with full permissions. They can invite and remove users, manage member permission levels, control case visibility, and access all cases.',
  },
  {
    type: 'Admin',
    content: 'Members with the same permissions as the Super Admin.',
  },
  {
    type: 'User',
    content:
      'Members with restricted access, limited to viewing only the cases they have created or cases set to public. They cannot manage other members or modify permissions.',
  },
]
